import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionArrowRight16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M16 8.15186C13.0873 8.15186 10.7236 10.7555 10.7236 13.97" stroke="currentColor" /><path d="M10.7236 2.3335C10.7236 5.54804 13.0873 8.15168 16 8.15168" stroke="currentColor" /><path d="M0 8.15186H16" stroke="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgDirectionArrowRight16);
export default ForwardRef;